/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateEmissionFactorDto } from '../models';
// @ts-ignore
import type { EmissionFactorCsvDataDto } from '../models';
// @ts-ignore
import type { EmissionFactorDto } from '../models';
// @ts-ignore
import type { ImportResultDto } from '../models';
// @ts-ignore
import type { UpdateEmissionFactorDto } from '../models';
// @ts-ignore
import type { UpdateEmissionFactorPairDto } from '../models';
/**
 * EmissionFactorsApi - axios parameter creator
 * @export
 */
export const EmissionFactorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateEmissionFactorDto} createEmissionFactorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emissionFactorsControllerCreateEmissionFactor: async (createEmissionFactorDto: CreateEmissionFactorDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmissionFactorDto' is not null or undefined
            assertParamExists('emissionFactorsControllerCreateEmissionFactor', 'createEmissionFactorDto', createEmissionFactorDto)
            const localVarPath = `/api/emission-factors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmissionFactorDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emissionFactorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emissionFactorsControllerDeleteEmissionFactor: async (emissionFactorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emissionFactorId' is not null or undefined
            assertParamExists('emissionFactorsControllerDeleteEmissionFactor', 'emissionFactorId', emissionFactorId)
            const localVarPath = `/api/emission-factors/{emissionFactorId}`
                .replace(`{${"emissionFactorId"}}`, encodeURIComponent(String(emissionFactorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emissionFactorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emissionFactorsControllerDuplicateEmissionFactor: async (emissionFactorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emissionFactorId' is not null or undefined
            assertParamExists('emissionFactorsControllerDuplicateEmissionFactor', 'emissionFactorId', emissionFactorId)
            const localVarPath = `/api/emission-factors/{emissionFactorId}/duplicate`
                .replace(`{${"emissionFactorId"}}`, encodeURIComponent(String(emissionFactorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emissionFactorsControllerExportEmissionFactorsCsv: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/emission-factors/csv-export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emissionFactorsControllerGetEmissionFactors: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/emission-factors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<EmissionFactorCsvDataDto>} emissionFactorCsvDataDto Emission factors CSV data array to import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emissionFactorsControllerImportEmissionFactorsCsv: async (emissionFactorCsvDataDto: Array<EmissionFactorCsvDataDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emissionFactorCsvDataDto' is not null or undefined
            assertParamExists('emissionFactorsControllerImportEmissionFactorsCsv', 'emissionFactorCsvDataDto', emissionFactorCsvDataDto)
            const localVarPath = `/api/emission-factors/csv-import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emissionFactorCsvDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emissionFactorId 
         * @param {UpdateEmissionFactorDto} updateEmissionFactorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emissionFactorsControllerUpdateEmissionFactor: async (emissionFactorId: string, updateEmissionFactorDto: UpdateEmissionFactorDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emissionFactorId' is not null or undefined
            assertParamExists('emissionFactorsControllerUpdateEmissionFactor', 'emissionFactorId', emissionFactorId)
            // verify required parameter 'updateEmissionFactorDto' is not null or undefined
            assertParamExists('emissionFactorsControllerUpdateEmissionFactor', 'updateEmissionFactorDto', updateEmissionFactorDto)
            const localVarPath = `/api/emission-factors/{emissionFactorId}`
                .replace(`{${"emissionFactorId"}}`, encodeURIComponent(String(emissionFactorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmissionFactorDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emissionFactorId 
         * @param {UpdateEmissionFactorPairDto} updateEmissionFactorPairDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emissionFactorsControllerUpdateEmissionFactorPair: async (emissionFactorId: string, updateEmissionFactorPairDto: UpdateEmissionFactorPairDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emissionFactorId' is not null or undefined
            assertParamExists('emissionFactorsControllerUpdateEmissionFactorPair', 'emissionFactorId', emissionFactorId)
            // verify required parameter 'updateEmissionFactorPairDto' is not null or undefined
            assertParamExists('emissionFactorsControllerUpdateEmissionFactorPair', 'updateEmissionFactorPairDto', updateEmissionFactorPairDto)
            const localVarPath = `/api/emission-factors/{emissionFactorId}/update-pair`
                .replace(`{${"emissionFactorId"}}`, encodeURIComponent(String(emissionFactorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmissionFactorPairDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmissionFactorsApi - functional programming interface
 * @export
 */
export const EmissionFactorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmissionFactorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateEmissionFactorDto} createEmissionFactorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emissionFactorsControllerCreateEmissionFactor(createEmissionFactorDto: CreateEmissionFactorDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emissionFactorsControllerCreateEmissionFactor(createEmissionFactorDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmissionFactorsApi.emissionFactorsControllerCreateEmissionFactor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} emissionFactorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emissionFactorsControllerDeleteEmissionFactor(emissionFactorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emissionFactorsControllerDeleteEmissionFactor(emissionFactorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmissionFactorsApi.emissionFactorsControllerDeleteEmissionFactor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} emissionFactorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emissionFactorsControllerDuplicateEmissionFactor(emissionFactorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emissionFactorsControllerDuplicateEmissionFactor(emissionFactorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmissionFactorsApi.emissionFactorsControllerDuplicateEmissionFactor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emissionFactorsControllerExportEmissionFactorsCsv(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmissionFactorCsvDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emissionFactorsControllerExportEmissionFactorsCsv(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmissionFactorsApi.emissionFactorsControllerExportEmissionFactorsCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emissionFactorsControllerGetEmissionFactors(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmissionFactorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emissionFactorsControllerGetEmissionFactors(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmissionFactorsApi.emissionFactorsControllerGetEmissionFactors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<EmissionFactorCsvDataDto>} emissionFactorCsvDataDto Emission factors CSV data array to import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emissionFactorsControllerImportEmissionFactorsCsv(emissionFactorCsvDataDto: Array<EmissionFactorCsvDataDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emissionFactorsControllerImportEmissionFactorsCsv(emissionFactorCsvDataDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmissionFactorsApi.emissionFactorsControllerImportEmissionFactorsCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} emissionFactorId 
         * @param {UpdateEmissionFactorDto} updateEmissionFactorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emissionFactorsControllerUpdateEmissionFactor(emissionFactorId: string, updateEmissionFactorDto: UpdateEmissionFactorDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emissionFactorsControllerUpdateEmissionFactor(emissionFactorId, updateEmissionFactorDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmissionFactorsApi.emissionFactorsControllerUpdateEmissionFactor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} emissionFactorId 
         * @param {UpdateEmissionFactorPairDto} updateEmissionFactorPairDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emissionFactorsControllerUpdateEmissionFactorPair(emissionFactorId: string, updateEmissionFactorPairDto: UpdateEmissionFactorPairDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emissionFactorsControllerUpdateEmissionFactorPair(emissionFactorId, updateEmissionFactorPairDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmissionFactorsApi.emissionFactorsControllerUpdateEmissionFactorPair']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmissionFactorsApi - factory interface
 * @export
 */
export const EmissionFactorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmissionFactorsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateEmissionFactorDto} createEmissionFactorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emissionFactorsControllerCreateEmissionFactor(createEmissionFactorDto: CreateEmissionFactorDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.emissionFactorsControllerCreateEmissionFactor(createEmissionFactorDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} emissionFactorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emissionFactorsControllerDeleteEmissionFactor(emissionFactorId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.emissionFactorsControllerDeleteEmissionFactor(emissionFactorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} emissionFactorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emissionFactorsControllerDuplicateEmissionFactor(emissionFactorId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.emissionFactorsControllerDuplicateEmissionFactor(emissionFactorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emissionFactorsControllerExportEmissionFactorsCsv(options?: RawAxiosRequestConfig): AxiosPromise<Array<EmissionFactorCsvDataDto>> {
            return localVarFp.emissionFactorsControllerExportEmissionFactorsCsv(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emissionFactorsControllerGetEmissionFactors(options?: RawAxiosRequestConfig): AxiosPromise<Array<EmissionFactorDto>> {
            return localVarFp.emissionFactorsControllerGetEmissionFactors(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<EmissionFactorCsvDataDto>} emissionFactorCsvDataDto Emission factors CSV data array to import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emissionFactorsControllerImportEmissionFactorsCsv(emissionFactorCsvDataDto: Array<EmissionFactorCsvDataDto>, options?: RawAxiosRequestConfig): AxiosPromise<ImportResultDto> {
            return localVarFp.emissionFactorsControllerImportEmissionFactorsCsv(emissionFactorCsvDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} emissionFactorId 
         * @param {UpdateEmissionFactorDto} updateEmissionFactorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emissionFactorsControllerUpdateEmissionFactor(emissionFactorId: string, updateEmissionFactorDto: UpdateEmissionFactorDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.emissionFactorsControllerUpdateEmissionFactor(emissionFactorId, updateEmissionFactorDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} emissionFactorId 
         * @param {UpdateEmissionFactorPairDto} updateEmissionFactorPairDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emissionFactorsControllerUpdateEmissionFactorPair(emissionFactorId: string, updateEmissionFactorPairDto: UpdateEmissionFactorPairDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.emissionFactorsControllerUpdateEmissionFactorPair(emissionFactorId, updateEmissionFactorPairDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmissionFactorsApi - object-oriented interface
 * @export
 * @class EmissionFactorsApi
 * @extends {BaseAPI}
 */
export class EmissionFactorsApi extends BaseAPI {
    /**
     * 
     * @param {CreateEmissionFactorDto} createEmissionFactorDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionFactorsApi
     */
    public emissionFactorsControllerCreateEmissionFactor(createEmissionFactorDto: CreateEmissionFactorDto, options?: RawAxiosRequestConfig) {
        return EmissionFactorsApiFp(this.configuration).emissionFactorsControllerCreateEmissionFactor(createEmissionFactorDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} emissionFactorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionFactorsApi
     */
    public emissionFactorsControllerDeleteEmissionFactor(emissionFactorId: string, options?: RawAxiosRequestConfig) {
        return EmissionFactorsApiFp(this.configuration).emissionFactorsControllerDeleteEmissionFactor(emissionFactorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} emissionFactorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionFactorsApi
     */
    public emissionFactorsControllerDuplicateEmissionFactor(emissionFactorId: string, options?: RawAxiosRequestConfig) {
        return EmissionFactorsApiFp(this.configuration).emissionFactorsControllerDuplicateEmissionFactor(emissionFactorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionFactorsApi
     */
    public emissionFactorsControllerExportEmissionFactorsCsv(options?: RawAxiosRequestConfig) {
        return EmissionFactorsApiFp(this.configuration).emissionFactorsControllerExportEmissionFactorsCsv(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionFactorsApi
     */
    public emissionFactorsControllerGetEmissionFactors(options?: RawAxiosRequestConfig) {
        return EmissionFactorsApiFp(this.configuration).emissionFactorsControllerGetEmissionFactors(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<EmissionFactorCsvDataDto>} emissionFactorCsvDataDto Emission factors CSV data array to import
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionFactorsApi
     */
    public emissionFactorsControllerImportEmissionFactorsCsv(emissionFactorCsvDataDto: Array<EmissionFactorCsvDataDto>, options?: RawAxiosRequestConfig) {
        return EmissionFactorsApiFp(this.configuration).emissionFactorsControllerImportEmissionFactorsCsv(emissionFactorCsvDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} emissionFactorId 
     * @param {UpdateEmissionFactorDto} updateEmissionFactorDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionFactorsApi
     */
    public emissionFactorsControllerUpdateEmissionFactor(emissionFactorId: string, updateEmissionFactorDto: UpdateEmissionFactorDto, options?: RawAxiosRequestConfig) {
        return EmissionFactorsApiFp(this.configuration).emissionFactorsControllerUpdateEmissionFactor(emissionFactorId, updateEmissionFactorDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} emissionFactorId 
     * @param {UpdateEmissionFactorPairDto} updateEmissionFactorPairDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmissionFactorsApi
     */
    public emissionFactorsControllerUpdateEmissionFactorPair(emissionFactorId: string, updateEmissionFactorPairDto: UpdateEmissionFactorPairDto, options?: RawAxiosRequestConfig) {
        return EmissionFactorsApiFp(this.configuration).emissionFactorsControllerUpdateEmissionFactorPair(emissionFactorId, updateEmissionFactorPairDto, options).then((request) => request(this.axios, this.basePath));
    }
}

